import angular from 'angular';
import PdfUploaderComponent from './pdf-uploader.component';
import Components from './components/components';

const PdfUploaderModule = angular
    .module('control-room.commons.content.components.pdf-uploader', [Components.name])
    .component('crPdfUploader', PdfUploaderComponent);

export default PdfUploaderModule;
